export const Console = (print = true) => ({
  log: (...args: any[]) => print && console.log(...args),
  time: (name: string) => print && console.time(name),
  timeEnd: (name: string) => print && console.timeEnd(name),
  error: (...args: any[]) => print && console.error(...args),
  groupCollapsed: (label: string) => print && console.group(label),
  groupEnd: () => print && console.groupEnd(),
});
